export const getInstances = (state) => {
    return state.constructs.bootloaders;
}